import React, { useState, useEffect, useRef } from "react";
import { getAllLiveEvents, getAllEvents } from "../api/EventsAPI.js";
import { useAuth } from "../contexts/AuthContext.js";
import "./styles/Landing.css";
import Navbar from "../components/Navbar.jsx";
import Home from "../sections/Home.jsx";
import Events from "../sections/Events.jsx";
import Video from "../sections/Video.jsx";
import Questions from "../sections/Questions.jsx";
import Contact from "../sections/Contact.jsx";
import Footer from "../sections/Footer.jsx";
import EventDetails from "../modals/EventDetails.js";
import { getAllFaqs } from "../api/FaqAPI.js";
import { useSearchParams, useLocation } from "react-router";

const Landing = () => {
  const { user } = useAuth();//TODO - check if user logged in else prompt to login
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const section = searchParams.get('to');
  const [eventData, seteventData] = useState([]);
  const [faqData, setfaqData] = useState([]);
  const [showEventDetailsModal, setshowEventDetailsModal] = useState(false);
  const eventSectionRef = useRef(null);
  const faqSectionRef = useRef(null);
  const contactSectionRef = useRef(null);


  useEffect(() => {
    if (location.hash) {
      const type = location.hash.replace('#', '');
      if (type) {
        handleScroll(type)
      }
    }
  }, [location]); // re-run if the route or hash changes


  useEffect(() => {
    if (section) {
      handleScroll(section)
    }
    initEventData()
    initFAQData()
  }, []);

  const handleScroll = (type) => {
    switch (type) {
      case 'home':
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'connect':
        window.scrollTo({ top: 0, behavior: 'smooth' });
        break;
      case 'events':
        eventSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'faq':
        faqSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      case 'contact':
        contactSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
        break;
      default:
        break;
    }
  };


  async function initEventData() {
    const res = await getAllLiveEvents() //DEV change
    if (res.success) {
      seteventData(res.events)
    }
  }

  async function initFAQData() {
    const res = await getAllFaqs()
    if (res.success) {
      setfaqData(res.faq)
    }
  }


  return (
    <div className="landing">
      <Navbar
        pageOn={'landing'}
        handleScroll={handleScroll} />
      <Home
        handleScroll={handleScroll} />
      <Events
        eventSectionRef={eventSectionRef}
        eventData={eventData}
      />
      <Video />
      <Questions
        faqSectionRef={faqSectionRef}
        faqData={faqData} />
      <Contact
        contactSectionRef={contactSectionRef} />
      <Footer
        pageOn={'landing'}
        handleScroll={handleScroll} />
      {/* modals */}
      {showEventDetailsModal &&
        <EventDetails
          setshowEventDetailsModal={setshowEventDetailsModal} />
      }
    </div>
  );
};

export default Landing;
